import { useNavigate } from 'react-router';
import LayoutWithSidebar from '../components/common/layoutWithSidebar';
import LandingPage from '../components/UserJourny/LandingPage';

const AddNewAssistant = () => {
  const navigate = useNavigate();

  const handleTemplateSelect = (template: any) => {
    // Format template name for URL
    const formattedName = template.name.replace(/\s+/g, '-').toLowerCase();
    navigate(`/add-new-assistant/${formattedName}`, {
      state: { selectedTemplate: template },
    });
  };

  return (
    <LayoutWithSidebar>
      <LandingPage onTemplateSelect={handleTemplateSelect} />
    </LayoutWithSidebar>
  );
};

export default AddNewAssistant;
